module.exports = __webpack_public_path__ + "img/freeshipping.045fe787.svg";